import { TextField } from '@wework/ray-core';
import flatpickr from 'flatpickr';
import { div } from 'client/javascript/util/dom_utils';
import { __ } from 'client/javascript/messages';

const RAY_TEXT_FIELD_CLASS = '.ray-text-field';
const FLATPICKR_FORM_FIELD_CLASSNAME = 'flatpickr--form-field';
const CLEAR_BUTTON_CLASSNAME = 'ray-button ray-button--tertiary flatpickr-calendar__clear';

export function setupDatePickerFormField(fieldId, options) {
  const input = document.querySelector(fieldId);
  if (!input) {
    return;
  }

  if (options.customValidation) {
    // will be called in the context of the DOM element
    input.checkValidity = function validityOverride() {
      return options.customValidation(this.value);
    };
  }

  const rayTextField = input.closest(RAY_TEXT_FIELD_CLASS);
  let rayTextFieldInstance = TextField.instances.get(rayTextField);
  if (!rayTextFieldInstance) {
    rayTextFieldInstance = TextField.create(rayTextField);
  }

  const datePickerInstance = flatpickr(input, { ...options, ...{ appendTo: rayTextField } });
  const clearButton = div({ className: CLEAR_BUTTON_CLASSNAME, html: __('Clear') });
  const { enableTime, noCalendar } = options;

  if (enableTime && noCalendar) {
    // Disable inputs tags to prevent manual input for time select
    datePickerInstance.timeContainer.querySelectorAll('.numInput').forEach((el) => {
      el.setAttribute('disabled', true);
    });
  }
  datePickerInstance.calendarContainer.appendChild(clearButton);
  datePickerInstance.calendarContainer.classList.add(FLATPICKR_FORM_FIELD_CLASSNAME);
  clearButton.addEventListener('click', () => {
    datePickerInstance.clear();
    datePickerInstance.close();
    datePickerInstance.calendarContainer.blur();
    rayTextFieldInstance.assignClasses();
  });
}
